function initiateGinBotanicalSelector() {
  document
    .querySelectorAll('.botanicals-selection-block')
    .forEach(block => {
      new window.GinBotanicalsSelection(block);
    });
}

if (!window.GinBotanicalsSelection) {
  window.GinBotanicalsSelection =
    class GinBotanicalsSelection {
      constructor(blockElement) {
        this.blockElement = blockElement;
        this.maxBotanicals = parseInt(blockElement.dataset.maxBotanicals) || 5;
        this.counterElement = blockElement.querySelector('.selected-count');
        this.botanicalItems = blockElement.querySelectorAll('.botanical-item');
        this.selectedBotanicals = [];

        this.#init();
      }

      #init() {
        this.#addEventListeners();
        this.#updateCounter();
      }

      #addEventListeners() {
        this.botanicalItems.forEach(item => {
          this.#addClickHandler(item);

          item.removeEventListener('click', item._clickHandler);
          item.addEventListener('click', item._clickHandler);
        });
      }

      #addClickHandler(item) {
        if (!item._clickHandler) {
          item._clickHandler = () => {
            if (!item.classList.contains('disabled')) {
              this.#toggleBotanical(item);
            }
          };
        }
      }

      #updateCounter() {
        this.counterElement.textContent = this.selectedBotanicals.length;

        // Disable/enable items based on selection limit
        this.botanicalItems.forEach(item => {
          if (!item.classList.contains('selected') && this.selectedBotanicals.length >= this.maxBotanicals) {
            item.classList.add('disabled');
          } else {
            item.classList.remove('disabled');
          }
        });
      }

      #toggleBotanical(item) {
        const botanicalId = item.dataset.botanical;
        const isSelected = item.classList.contains('selected');

        if (isSelected) {
          // Remove botanical
          this.selectedBotanicals = this.selectedBotanicals.filter(id => id !== botanicalId);
          item.classList.remove('selected');
        } else if (this.selectedBotanicals.length < this.maxBotanicals) {
          // Add botanical
          this.selectedBotanicals.push(botanicalId);
          item.classList.add('selected');
        }

        this.#updateCounter();

        // Dispatch custom event for integration with other components
        document.dispatchEvent(new CustomEvent('botanicals-changed', {
          detail: {
            selectedBotanicals: this.selectedBotanicals,
            count: this.selectedBotanicals.length,
            maxCount: this.maxBotanicals
          }
        }));
      }

      #getSelectedBotanicals() {
        return this.selectedBotanicals;
      }

      reset() {
        this.selectedBotanicals = [];
        this.botanicalItems.forEach(item => {
          item.classList.remove('selected');
        });
        this.#updateCounter();
      }
    }
  initiateGinBotanicalSelector();
}

document.addEventListener('DOMContentLoaded', () => {
  initiateGinBotanicalSelector();
});

document.addEventListener('modal-opened', () => {
  initiateGinBotanicalSelector();
});
